import {Injectable} from '@angular/core';
import {ToastController} from '@ionic/angular';

@Injectable({
    providedIn: 'root'
})
export class ToastService {
    toast: any;

    constructor(public toastController: ToastController) {
    }

    async message(message: string, color = 'tertiary') {
        await this.show({
            duration: 10000,
            message,
            color
        });
    }

    async success(message: string) {
        await this.show({
            duration: 5000,
            message,
            color: 'success'
        });
    }

    async error(message: string) {
        await this.show({
            duration: 10000,
            message,
            color: 'danger'
        });
    }

    async show(details: any) {
        if (!!this.toast) {
            this.toast.dismiss();
        }

        const toast = await this.toastController.create(
            {
                position: 'top',
                duration: details.duration,
                buttons: [
                    {
                        side: 'end',
                        icon: 'close'
                    }
                ],
                message: details.message,
                color: details.color
            });

        await toast.present();
        toast.onDidDismiss().then(() => {
            this.toast = null;
        });
        this.toast = toast;
    }

    async hide() {
        if (!!this.toast) {
            await this.toastController.dismiss();
            this.toast = null;
        }
    }
}
